import React, { ButtonHTMLAttributes } from 'react';
import { IconBaseProps } from 'react-icons';

import { Container } from './styles';

interface OperationButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  title: string;
  icon?: React.ComponentType<IconBaseProps>;
}

const OperationButton: React.FC<OperationButtonProps> = ({
  title,
  icon: Icon,
  ...rest
}) => {
  return (
    <Container {...rest}>
      {title} {Icon && <Icon size={20} />}
    </Container>
  );
};

export default OperationButton;
